import type { FaireProductEntity } from "../../entity_types/product";

export const p_r7bhctpgwf: FaireProductEntity = {
  token: "p_r7bhctpgwf",
  type: "product",
  name: "Mo&Co Home Exclusive: Sculpted Beeswax Pine Cones | 2 Sizes",
  brandToken: "b_94ned2lnmo",
  brandName: "Mo&Co Home",
  imageUrl:
    "https://cdn.faire.com/fastly/ca37fb5f1fd81b9beb7dae6a29cf2570b25cff13682319e191f9079fc1785fda.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3e857931b14de924cb8fb34a30177ef225555b622cb231955ec7ddadfb8253ff.jpeg",
    "https://cdn.faire.com/fastly/ac51b361b8cab3f510dcb10ee381594b63b869bb15e328e881db8889389cd81e.jpeg",
    "https://cdn.faire.com/fastly/20c1750e753691500cc29127f96149b0d1e019877bf1bffbacf6634595dc5dad.jpeg",
    "https://cdn.faire.com/fastly/36c0a4f78b335e2da1c7a3e2c1384d9ec9ee6c5a0c2ab5ddcc346cb1468cc112.jpeg",
    "https://cdn.faire.com/fastly/cf052e8436a478fd3cfe969ccffb065e9468ae1ab2ca66d8ec66b730b5b8ac12.jpeg",
    "https://cdn.faire.com/fastly/762689cf1f64610851e1a454c698c2324fb7bb9a533c3a2722e4a1c53884bcc3.jpeg",
    "https://cdn.faire.com/fastly/9df41b49674256228e40d416a6058bd16b82f1c621053c52348b05e5847bbc20.jpeg",
    "https://cdn.faire.com/fastly/60539a5df45786da25accd077fc8fb69b4715dc444b1b694233028df625fa329.jpeg",
  ],
  priceDollars: 9,
  description:
    'These Mo&Co Home exclusive, hand-poured 100% beeswax candles are inspired by the fractal geometry and spiralling shapes of pine cones. Designed to evoke holiday nostalgia with a refined, contemporary style, they bring warmth, elegance, and a sculptural touch to seasonal gatherings and holiday gifting.\n\nOur in-studio sculptor, Carrie, designed these one of a kind pine cone candles. The creation began with a custom digital design followed by a hand-refined 3D-printed model. Our candlemakers then crafted the molds and hand-poured each candle in pure beeswax. Through thoughtful craftsmanship, these candles are the union of artistry and exceptional quality.\n\nIngredients:\n100% Beeswax\nCotton Wick\nEco-conscious coloring\n\nAvailable in 2 sizes:\nSmall: Height: 2 3/4"  Diameter: 2 2/8"\nLarge: Height: 4"  Diameter: 2 3/4"\n\nSold Individually',
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:26.130Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
